import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'caseGroupCreationPrecodesPipe',
   pure: false
})
export class CaseGroupCreationPrecodesPipePipe implements PipeTransform {

  transform(codesData: any[], searchTermpre: string): any[]  {
    if (!codesData || !searchTermpre) { return codesData; }
    return codesData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTermpre.toLowerCase().trim()) !== -1
   


    );
  }

}
